'use client';

import Image from 'next/image';
import Link from 'next/link'
import { FormattedMessage } from 'react-intl'

export default function RightPanel() {
  return (
    <>
      <style>
        {`
          .branded-bg {
            background-image: url('${('/assets/media/app/marketplace-bg.png')}');
          }
          .dark .branded-bg {
            background-image: url('${('/assets/media/app/marketplace-bg.png')}');
          }
            
        `}
      </style>
      <div className="lg:rounded-xl lg:border lg:border-gray-200 lg:m-5 order-1 lg:order-2 bg-top bg-no-repeat xxl:bg-center xl:bg-cover branded-bg overflow-hidden">
        <div className="flex flex-col p-8 lg:p-16 gap-4 h-full rounded-xl" >
          <Link href="/">
            <Image
              src="/assets/media/app/marketplace.png"
              alt="Marketplace Logo"
              className="h-[auto] max-w-none"
              width={250}
              height={100}
            />
          </Link>

          <div className="flex flex-col gap-3">
            <h3 className="text-2xl font-semibold text-gray-900"><FormattedMessage id="RIGHT_PANEL.SECURE_ACCESS_PORTAL" /></h3>
            <div className="text-base font-medium text-gray-600">
              <FormattedMessage id="RIGHT_PANEL.AUTHENTICATION_GATEWAY" /> <br />
              <FormattedMessage id="RIGHT_PANEL.SECURE" /> <span className="text-gray-900 font-semibold"><FormattedMessage id="RIGHT_PANEL.EFFICIENT_USER_ACCESS" /></span> <FormattedMessage id="RIGHT_PANEL.T3ELEMENT" /><br />
              <FormattedMessage id="RIGHT_PANEL.DASHBOARD_INTERFACE" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
